module.exports = __webpack_public_path__ + "img/WhatsAppaccueil.51fa1174.jpeg";